// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"73":"stps-ocupaciones","884":"am","932":"times-zones"}[chunkId] || chunkId) + "." + {"73":"b0273f24","629":"cd21e849","636":"e0b59052","884":"b2db3fe7","932":"75498f6b"}[chunkId] + ".css";
};